// A plan with no end date (an admin-given one runs to 9999) gives its tokens month by month,
// each month's lapsing at its end (Tony, 3 Nov 2026), so Billing shows the month, not the
// period. The same rule and month arithmetic as the API's ledger (services/tokenLedgerShadowService.ts:
// a period longer than a year; months counted in UTC from the period's start, a month from the
// 31st ending on a shorter month's last day).

function monthStart(start: Date, k: number): Date {
  const y = start.getUTCFullYear();
  const m = start.getUTCMonth() + k;
  const last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
  return new Date(Date.UTC(y, m, Math.min(start.getUTCDate(), last), start.getUTCHours(), start.getUTCMinutes(), start.getUTCSeconds()));
}

/** This month of a plan with no end date, from its start to when its tokens renew; null for a paid period. */
export function currentMonthOf(periodStart: string, periodEnd: string, now: Date = new Date()): { start: Date; end: Date } | null {
  const start = new Date(periodStart);
  if (new Date(periodEnd) < monthStart(start, 13)) return null;
  let k = 0;
  while (monthStart(start, k + 1) <= now) k++;
  return { start: monthStart(start, k), end: monthStart(start, k + 1) };
}
